import { mapValues } from 'lodash';
import {
  PollPinLayoutTemplate,
  PollPinSettingsEmoji,
  PollPinSettingsText,
  PollPinSettingType,
  PollTeacherPin,
} from '../../models';
import { stringToLeanProsemirror } from '../../tip-tap';
import { randomId } from '../random-id';
import { PinCreationParams } from './pin-helper-types';

export const newPollPin = (
  layout: PollPinLayoutTemplate,
  pollType: PollPinSettingType = 'EMOJI'
): PinCreationParams<PollTeacherPin> => {
  const basePin: PinCreationParams<PollTeacherPin> = {
    type: 'POLL',
    settings: {
      layout: layout.key,
      backgroundColor: layout.backgroundColor,
      backgroundImage: layout.backgroundImage,
      questionId: layout.layoutParts.TITLE?.id,
      layoutParts: mapValues(layout.layoutParts, (comp) => comp?.id),
      ...(pollType === 'EMOJI'
        ? {
            type: 'EMOJI',
            answers: pollEmojiAnswers,
          }
        : {
            type: 'TEXT',
            answers: pollTextAnswers,
          }),
    },
    teacherSettings: {},
    pinComponents: [...Object.values(layout.layoutParts), ...layout.pinComponents],
  };

  if ('backgroundTransparency' in layout && layout.backgroundTransparency !== undefined) {
    basePin.settings.backgroundTransparency = layout.backgroundTransparency;
  }

  return basePin;
};

export const pollEmojiAnswers: PollPinSettingsEmoji['answers'] = [
  // we use the names from https://emojipedia.org as ids
  { id: 'frowning-face-with-open-mouth', text: '😦' },
  { id: 'slightly-frowning-face', text: '🙁' },
  { id: 'neutral-face', text: '😐' },
  { id: 'slightly-smiling-face', text: '🙂' },
  { id: 'grinning-face-with-big-eyes', text: '😃' },
];

export const pollTextAnswers: PollPinSettingsText['answers'] = Array.from({ length: 2 }, () => ({
  id: randomId(),
  text: stringToLeanProsemirror(''),
}));
